import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32b8301a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-overview-details gap-4 flex flex-row flex-nowrap" }
const _hoisted_2 = { class: "details flex flex-col justify-between flex-1" }
const _hoisted_3 = { class: "legend grid grid-cols-[7fr_3fr] gap-1" }
const _hoisted_4 = { class: "name flex flex-row flex-nowrap self-center items-center gap-2" }
const _hoisted_5 = { class: "gordita-400-12 text-Text/text_medium" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "gordita-400-12 text-Text/text_high" }


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-overview-details',
  props: {
    legend: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title"),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.legend, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.title
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["w-2 h-2 rounded-full", item.class])
              }, null, 2),
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.value), 1)
            ])
          ], 64))
        }), 128))
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})